document.addEventListener('DOMContentLoaded', function () {
  const images = Array.from(
    document.querySelectorAll(
      '.spectronics-product-content img.spectronics-lightbox'
    )
  );

  if (!images.length) return;

  let currentIndex = 0;

  const modal = document.createElement('div');
  modal.className = 'spectronics-image-lightbox';
  modal.setAttribute('role', 'dialog');
  modal.setAttribute('aria-modal', 'true');
  modal.setAttribute('aria-label', 'Product image gallery');

  modal.innerHTML = `
    <button
      class="spectronics-image-lightbox__close"
      type="button"
      aria-label="Close image"
    >
      &times;
    </button>

    <button
      class="spectronics-image-lightbox__arrow spectronics-image-lightbox__arrow--previous"
      type="button"
      aria-label="Previous image"
    >
      &#10094;
    </button>

    <div class="spectronics-image-lightbox__content">

      <img
        class="spectronics-image-lightbox__image"
        src=""
        alt=""
      >

      <div class="spectronics-image-lightbox__caption"></div>

      <div class="spectronics-image-lightbox__counter"></div>

    </div>

    <button
      class="spectronics-image-lightbox__arrow spectronics-image-lightbox__arrow--next"
      type="button"
      aria-label="Next image"
    >
      &#10095;
    </button>
  `;

  document.body.appendChild(modal);

  const modalImage = modal.querySelector(
    '.spectronics-image-lightbox__image'
  );

  const caption = modal.querySelector(
    '.spectronics-image-lightbox__caption'
  );

  const counter = modal.querySelector(
    '.spectronics-image-lightbox__counter'
  );

  const closeButton = modal.querySelector(
    '.spectronics-image-lightbox__close'
  );

  const previousButton = modal.querySelector(
    '.spectronics-image-lightbox__arrow--previous'
  );

  const nextButton = modal.querySelector(
    '.spectronics-image-lightbox__arrow--next'
  );


  function getFullImageSource(image) {
    /*
      Optional:
      If data-lightbox-src exists, use that as the large image.

      Otherwise use the image's normal source.
    */
    return (
      image.dataset.lightboxSrc ||
      image.currentSrc ||
      image.src
    );
  }


  function showImage(index) {
    if (index < 0) {
      index = images.length - 1;
    }

    if (index >= images.length) {
      index = 0;
    }

    currentIndex = index;

    const sourceImage = images[currentIndex];

    modalImage.src = getFullImageSource(sourceImage);
    modalImage.alt = sourceImage.alt || '';

    caption.textContent = sourceImage.alt || '';

    counter.textContent =
      `${currentIndex + 1} / ${images.length}`;


    if (images.length <= 1) {

      previousButton.style.display = 'none';
      nextButton.style.display = 'none';
      counter.style.display = 'none';

    } else {

      previousButton.style.display = '';
      nextButton.style.display = '';
      counter.style.display = '';

    }
  }


  function openLightbox(index) {
    showImage(index);

    modal.classList.add('is-open');

    document.body.style.overflow = 'hidden';

    closeButton.focus();
  }


  function closeLightbox() {
    modal.classList.remove('is-open');

    modalImage.src = '';

    document.body.style.overflow = '';
  }


  function previousImage() {
    showImage(currentIndex - 1);
  }


  function nextImage() {
    showImage(currentIndex + 1);
  }


  /*
    Every image with:
    class="spectronics-lightbox"

    automatically joins the gallery.
  */

  images.forEach(function (image, index) {

    image.setAttribute('tabindex', '0');
    image.setAttribute('role', 'button');
    image.setAttribute('aria-label', 'Enlarge image');

    image.addEventListener('click', function () {
      openLightbox(index);
    });

    image.addEventListener('keydown', function (event) {

      if (
        event.key === 'Enter' ||
        event.key === ' '
      ) {
        event.preventDefault();

        openLightbox(index);
      }

    });

  });


  previousButton.addEventListener(
    'click',
    previousImage
  );


  nextButton.addEventListener(
    'click',
    nextImage
  );


  closeButton.addEventListener(
    'click',
    closeLightbox
  );


  modal.addEventListener('click', function (event) {

    if (event.target === modal) {
      closeLightbox();
    }

  });


  document.addEventListener('keydown', function (event) {

    if (!modal.classList.contains('is-open')) {
      return;
    }


    if (event.key === 'Escape') {
      closeLightbox();
    }


    if (event.key === 'ArrowLeft') {
      previousImage();
    }


    if (event.key === 'ArrowRight') {
      nextImage();
    }

  });
});